var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.tokens),function(token,index){return _c('span',{key:index,class:[token.type]},[_vm._v("\n    "+_vm._s(token.string)+"\n  ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }